var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilLifeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "44.28px",
    viewBox: "0 0 72 44.28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Safety/SafetyAlert/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Health_Warning_03",
    transform: "translate(-171.000000, -299.320000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety/SafetyAlert/32",
    transform: "translate(171.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,46.8 L61.2,46.8 C61.2,50.76 57.96,54 54,54 C50.04,54 46.8,50.76 46.8,46.8 L43.2,46.8 C43.2,50.76 39.96,54 36,54 C32.04,54 28.8,50.76 28.8,46.8 L25.2,46.8 C25.2,50.76 21.96,54 18,54 C14.04,54 10.8,50.76 10.8,46.8 L7.2,46.8 C7.2,50.76 3.96,54 0,54 L0,57.6 C3.78,57.6 7.02,55.62 9,52.74 C10.98,55.62 14.22,57.6 18,57.6 C21.78,57.6 25.02,55.62 27,52.74 C28.98,55.62 32.22,57.6 36,57.6 C39.78,57.6 43.02,55.62 45,52.74 C46.98,55.62 50.22,57.6 54,57.6 C57.78,57.6 61.02,55.62 63,52.74 C64.98,55.62 68.22,57.6 72,57.6 L72,54 C68.04,54 64.8,50.76 64.8,46.8 Z M68.4,28.8 C68.4,28.8 72,34.02 72,36 C72,37.98 70.38,39.6 68.4,39.6 C66.42,39.6 64.8,37.98 64.8,36 C64.8,34.02 68.4,28.8 68.4,28.8 Z M3.96,13.32 L18,18.9 L18,21.6 L25.2,21.6 L25.2,18 L21.6,18 L21.6,14.4 L32.4,14.4 L32.4,18 L28.8,18 L28.8,21.6 L36,21.6 L39.42,24.84 L65.52,20.7 L69.12,24.3 L66.6,27 L64.26,24.66 L61.2,25.2 L46.8,39.6 L14.4,39.6 L14.4,29.16 L8.52651283e-14,23.4 L3.96,13.32 Z M34.56,25.2 L18,25.2 L18,36 L45.36,36 L55.08,26.28 L38.16,28.8 L34.56,25.2 Z M5.94,18 L4.68,21.42 L14.4,25.2 L14.4,21.42 L5.94,18 Z",
    id: "Icon",
    fill: "#00095B",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilLifeIcon);
export default __webpack_public_path__ + "static/media/oil-life-icon.078c267d0c95ce6a3aa1393fa6ea41a9.svg";
export { ForwardRef as ReactComponent };